import axios from 'axios';

export const getRequest = async (id) => {
    const url = `/api/v1/user_profile/request/requests/${id}`;
    const res = await axios.get(url);
    return res.data;
};